import { createSlice } from "@reduxjs/toolkit";

const myUserSlice = createSlice({
    name: "myUserSlice",
    initialState: {
        user: {},
        token: "",
        isRefreshingToken: false,
        providerData: {},
        merchantId: "",
        license: {}
    }
    ,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setIsRefreshingToken: (state, action) => {
            state.isRefreshingToken = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setProviderData: (state, action) => {
            state.providerData = action.payload;
        },
        setMerchantId: (state, action) => {
            state.merchantId = action.payload;
        },
        setLicense: (state, action) => {
            state.license = action.payload
        }

    },
});

export default myUserSlice;
